import "normalize.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./filters";
import ajax from "./utils/ajax";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";

import fundebug from "fundebug-javascript";
import fundebugVue from "fundebug-vue";
import "fundebug-revideo";

import baiduAnalytics from "vue-baidu-analytics";

if (process.env.NODE_ENV === "production") {
  // 百度统计
  Vue.use(baiduAnalytics, {
    router: router,
    siteIdList: ["0e03ed2b21c5737299c6a7acb5197580"],
    isDebug: false,
  });

  // 代码监控
  fundebug.init({
    apikey: "5fe3b3faeb59c5f0552ad179eaa977a3a67340abf4794924994ccd21645da603",
    appversion: "0.0.4",
    releasestage: "production",
    setHttpBody: true,
  });
  fundebugVue(fundebug, Vue);
}

Vue.use(VideoPlayer);
Vue.prototype.$axios = ajax;

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
